import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import ViewWarehouse from '../../../../component/b2c/models/ViewWarehouse';
import { useMyContext } from '../../context/MyContext';
import Swal from 'sweetalert2';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import NavBar from '../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../css/custom-scrollbar.css';
import { LuWarehouse } from "react-icons/lu";
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { Base_Url, fetchOffers, deleteOffer } from '../../config/config';
import ViewOffer from '../../component/b2c/models/viewAllOfferModel';

const AllOffers = () => {
    const [totalOrders, setTotalOrders] = useState(0);
    const { isDarkMode } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { isToggleSidebar } = useMyContext();
    const [offers, setOffers] = useState([]);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [loadingOfferId, setLoadingOfferId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchOffersData();
    }, [page, limit]);

    const fetchOffersData = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        try {
            const pageNumber = Number(page) || 1;
            const limitNumber = Number(limit) || 10;
            const urlOffers = `${Base_Url}${fetchOffers}?page=${pageNumber}&limit=${limitNumber}`;
            const response = await fetch(urlOffers, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cusid,
                    'Content-Type': 'application/json'
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "SUCCESS" && Array.isArray(result.data)) {
                setOffers(result.data);
                setTotalOrders(result.pagination.totalItems || 0);
            } else {
                console.error('Unexpected response format:', result);
            }
        } catch (error) {
            console.error('Error fetching offers data:', error);
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
        setCurrentPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
        setCurrentPage(1);
    };

    const handleViewClick = (offer) => {
        setSelectedOffer(offer);
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleNavigation = () => {
        navigate('/dashboard');
    };

    const handleDelete = (id) => {
    setLoadingOfferId(id);
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this deletion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.isConfirmed) {
            const urldelete = Base_Url + deleteOffer + "/" + id;
            const token = localStorage.getItem('token');
            const cusid = localStorage.getItem('cus_id');

            fetch(urldelete, {
                method: "GET", 
                headers: {
                    "Content-Type": "application/json",
                    "token": token,
                    "cus_id": cusid,
                },
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === "SUCCESS") {
                    setOffers((prevOffers) => prevOffers.filter((offer) => offer.id !== id));
                    setTotalOrders((prev) => prev - 1);

                    Swal.fire(
                        'Deleted!',
                        data.message || 'Offer has been deleted successfully.',
                        'success'
                    );
                } else {
                    Swal.fire(
                        'Error!',
                        'Unexpected response format: ' + data.message,
                        'error'
                    );
                }
            })
            .catch((error) => {
                Swal.fire(
                    'Error!',
                    'Error deleting offer: ' + error.message,
                    'error'
                );
            })
            .finally(() => {
                setLoadingOfferId(null);
            });
        } else {
            setLoadingOfferId(null);
        }
    });
};



    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const getFilteredOffers = () => {
        if (!searchTerm.trim()) {
            return offers;
        }

        const term = searchTerm.toLowerCase();
        return offers.filter(offer => {
            return (
                (offer.id?.toString().toLowerCase().includes(term)) ||
                (offer.coupon_code?.toLowerCase().includes(term)) ||
                (offer.category?.toLowerCase().includes(term)) ||
                (offer.discount_type?.toLowerCase().includes(term))
            );
        });
    };

    const displayOffers = getFilteredOffers();

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="z-10">
                    <NavBar />
                </div>

                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            }>
                            <Sidebar />
                        </div>
                    )}

                    <div className={`shadow-custom-light overflow-x-hidden ml-4 mt-6 mb-6 mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
                        <button onClick={handleNavigation}
                            className="text-xl w-full sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px] sm:w-full flex items-center justify-center">
                            <LuWarehouse className="mr-2" size={24} />
                            All Offers
                        </button>
                        <div className="mb-8">
                            <div className="relative group">
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                <div className="relative flex items-center bg-white dark:bg-darkmodeColor border-2 border-gray-200 dark:border-gray-700 rounded-xl shadow-sm hover:shadow-md focus-within:shadow-lg focus-within:border-customPurple transition-all duration-300">
                                    <div className="pl-4 pr-3">
                                        <CgSearch className="text-gray-400 dark:text-gray-300 transition-colors duration-200 group-focus-within:text-customPurple" size={20} />
                                    </div>

                                    <input
                                        type="text"
                                        placeholder="Search by Id / Coupon Code / Category / Discount Type"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        className="flex-1 p-4 bg-transparent outline-none dark:text-white text-gray-700 placeholder-gray-400 dark:placeholder-gray-300 text-sm font-medium"
                                    />

                                    {searchTerm && (
                                        <button
                                            onClick={() => handleSearchChange({ target: { value: '' } })}
                                            className="mr-4 p-1 text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-red-50 dark:hover:bg-red-900/20"
                                        >
                                            <span className="sr-only">Clear search</span>
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="min-w-full table-auto overflow-y-auto">
                                <thead className='bg-gradient-to-r from-[#0540a6] to-[#0650c4] text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                                    <tr>
                                        <th className='p-2 text-left font-semibold'>Offer ID</th>
                                        <th className='p-2 text-left font-semibold'>Coupon Code</th>
                                        <th className='p-2 text-left font-semibold'>Category</th>
                                        <th className='p-2 text-left font-semibold'>Discount Type</th>
                                        <th className='p-2 text-left font-semibold'>Discount Value</th>
                                        <th className='p-2 text-left font-semibold'>Start Date</th>
                                        <th className='p-2 text-left font-semibold'>End Date</th>
                                        <th className='p-2 text-left font-semibold'>Status</th>
                                        <th className='p-2 text-left font-semibold'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                                    {displayOffers.map((offer, index) => (
                                        <tr
                                            key={offer.id}
                                            className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                                                ? 'bg-white dark:bg-darkmodeColor'
                                                : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                                                }`}
                                        >
                                            <td className='p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors'>
                                                {offer.id}
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{offer.coupon_code}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{offer.category}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{offer.discount_type}</td>
                                            <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                                                {offer.discount_type === 'Percentage' ? `${offer.discount_value}%` : `₹${offer.discount_value}`}
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{offer.start_date}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{offer.end_date}</td>
                                            <td className='p-3'>
                                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${offer.status === 'Active'
                                                    ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                                    : offer.status === 'Scheduled'
                                                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                                        : offer.status === 'Expired'
                                                            ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                                            : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                                    }`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${offer.status === 'Active'
                                                        ? 'bg-white animate-pulse'
                                                        : offer.status === 'Scheduled'
                                                            ? 'bg-white'
                                                            : offer.status === 'Expired'
                                                                ? 'bg-white'
                                                                : 'bg-gray-500'
                                                        }`}></span>
                                                    {offer.status || 'Active'}
                                                </span>
                                            </td>
                                            <td className='p-2'>
                                                <div className='flex items-center gap-1'>
                                                    <Button
                                                        onClick={() => handleViewClick(offer)}
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                                        style={{
                                                            backgroundColor: '#3b82f6',
                                                            '&:hover': { backgroundColor: '#2563eb' }
                                                        }}
                                                    >
                                                        <IoMdEye className="text-xs" />
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleDelete(offer.id)}
                                                        variant="contained"
                                                        color="error"
                                                        size="small"
                                                        disabled={loadingOfferId === offer.id}
                                                        className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                                        style={{
                                                            backgroundColor: loadingOfferId === offer.id ? '#f8d7da' : '#ef4444',
                                                            color: loadingOfferId === offer.id ? '#721c24' : 'white',
                                                            '&:hover': { backgroundColor: loadingOfferId === offer.id ? '#f8d7da' : '#dc2626' }
                                                        }}
                                                    >
                                                        {loadingOfferId === offer.id ? (
                                                            <span className="animate-spin">⏳</span>
                                                        ) : (
                                                            <MdDelete className="text-xs" />
                                                        )}
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                                <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Offers: ${totalOrders}`}</span>
                                <select
                                    id="limit"
                                    value={limit}
                                    onChange={handleLimitChange}
                                    className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                                    disabled={totalOrders < 10}
                                >
                                    {totalOrders === 0 ? (
                                        <option value={0}>0</option>
                                    ) : (
                                        <>
                                            <option value={10}>10</option>
                                            <option value={15}>15</option>
                                            <option value={20}>20</option>
                                            <option value={30}>30</option>
                                            <option value={totalOrders}>All</option>
                                        </>
                                    )}
                                </select>

                                <Pagination
                                    count={Math.ceil(totalOrders / limit)}
                                    page={currentPage}
                                    onChange={handlePaginationChange}
                                    variant="outlined"
                                    shape="rounded"
                                    className="pagination"
                                    size="small"
                                    renderItem={(item) => (
                                        <PaginationItem
                                            {...item}
                                            className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <ViewOffer isopen={isPopupOpen} onClose={handleClose} offer={selectedOffer} />
            </div>
        </>
    );
};

export default AllOffers;